import { FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { supplyCategoriesByEpisodeCategory } from '@common/constants/supplyCategoriesByEpisodeCategory';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrderSuppliesFormState } from '../../types/orderSuppliesFormState';
import type { OrderSuppliesRouteParams } from '../../types/orderSuppliesRouteParams';
import { routeParamToEpisodeCategory, routeParamToSupplyCategory } from '../../utils/orderSuppliesRouteUtils';

export function OrderSuppliesDeliveryLocation() {
    const translate = getSelectedLanguage();
    const form = useFormContext<OrderSuppliesFormState>();
    const { episodeCategory: episodeCategoryParam, supplyCategory: supplyCategoryParam } =
        useParams() as OrderSuppliesRouteParams;

    const episodeCategory = episodeCategoryParam ? routeParamToEpisodeCategory(episodeCategoryParam) : undefined;
    const supplyCategory = supplyCategoryParam ? routeParamToSupplyCategory(supplyCategoryParam) : undefined;

    if (
        !episodeCategory ||
        !supplyCategory ||
        !supplyCategoriesByEpisodeCategory[episodeCategory]?.[supplyCategory]?.hasDeliveryLocation
    ) {
        return null;
    }

    return (
        <FormSection title={translate.orderSupplies.deliveryLocation}>
            <FormGroup
                isRequired={true}
                label={translate.organizationTypeEnum.pharmacy}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('delivery.pharmacy')}
                    name="delivery.pharmacy"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.delivery?.pharmacy ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.organization.streetName}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('delivery.street')}
                    name="delivery.street"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.delivery?.street ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.houseNumber}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('delivery.houseNumber')}
                    name="delivery.houseNumber"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.delivery?.houseNumber ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.zipcode}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('delivery.zipCode')}
                    name="delivery.zipCode"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.delivery?.zipCode ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.city}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('delivery.city')}
                    name="delivery.city"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.delivery?.city ?? ''}
                />
            </FormGroup>
        </FormSection>
    );
}
